<template>
  <div class="thumb-buttons">
    <ThumbButton
      class="thumb-button"
      :class="positiveClasses"
      @click.native="toggleActive('positive')"
    >
      <img
        :src="require('@/assets/images/thumb.png')"
        alt=""
        draggable="false"
      />
    </ThumbButton>
    <ThumbButton
      class="thumb-button"
      :class="negativeClasses"
      @click.native="toggleActive('negative')"
      negative
    >
      <img
        :src="require('@/assets/images/thumb.png')"
        alt=""
        draggable="false"
        class="flip"
      />
    </ThumbButton>

    <Content
      dark
      small
      class="feedback-message"
      v-if="feedbackMessage"
      v-html="feedbackMessage"
    ></Content>
  </div>
</template>

<script>
import { Content } from '@/components/chapter'
import ThumbButton from './ThumbButton'
import { trackFeedback } from '@/utils/track'

export default {
  name: 'ThumbButtons',
  data () {
    return {
      state: null,
      tracked: false
    }
  },
  components: {
    ThumbButton,
    Content
  },
  methods: {
    toggleActive (newState) {
      if (!this.tracked) {
        trackFeedback(newState)
      }
      this.tracked = true
      this.state = (this.state === newState) ? null : newState
    }
  },
  computed: {
    positiveClasses () {
      return {
        'is-faded': this.state === 'positive'
      }
    },
    negativeClasses () {
      return {
        'is-faded': this.state === 'negative'
      }
    },
    feedbackMessage () {
      if (this.state === 'positive') {
        return `<p style="color: #65C7C2;">Goed om te horen!</p>
        <p>Heb je nog andere feedback? Dan horen we dat graag van je!</p>`
      } else if (this.state === 'negative') {
        return `<p style="color: #f66;">Dat is jammer, we horen graag meer! Laat je feedback achter</p>`
      } else {
        return null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.thumb-buttons {
  font-size: 0;
  text-align: center;
}

.thumb-button + .thumb-button {
  margin-left: 42px;
}

.is-faded {
  opacity: 0.5;
}

.feedback-message {
  margin-top: 30px;
  text-align: center;
  max-width: 287px;
  margin-left: auto;
  margin-right: auto;
}

.flip {
  transform: rotate(180deg);
}
</style>
